const pages = {
  about: {
    hero: {
      badge: "EST. 2002 • GUJARAT'S LARGEST SANCTUARY",
      titleStart: "A home where ",
      titleHighlight: "every elder",
      titleEnd: " is family.",
      description:
        "Founded in 2002 by the benevolence of the late Shree Champaklal Ghelabhai Shah, Jivandhara Old Age Home is a warm, loving family. Starting with just 17 residents on a 10,000 square yard sanctuary in Lambha, Ahmedabad, we are now Gujarat's largest old age home, proudly caring for over 300 cherished seniors.",
      supportCause: "Support Our Cause",
      visitHome: "Visit the Home",
      quote:
        "\"Seva is not what we do for others. It is who we become together.\"",
      founderName: "Shri Manharlal Shah",
      founderRole: "Founder Trustee, Jivandhara Old Age Home",
      poem: {
        title: "What is Jivandhara?",
        intro: "If someone asks, what is Jivandhara?\nThen I proudly say...",
        lines: [
          "Jivandhara is a sanctuary of rest and trust,",
          "A seed sown in the year 2002, today Jivandhara is a grand banyan tree,",
          "In a dry, parched desert, Jivandhara is a sweet, flowing stream,",
          "In a scorching heat, Jivandhara is the cool shade of a banyan tree,",
          "In the lonely world of elders, Jivandhara is like a cuckoo singing on a mango branch,",
          "Jivandhara is the shelter and the daily bread of the helpless,",
          "The hope in tearful eyes, Jivandhara is the sweet smile of old age,",
          "Where old age sways on a swing, and hymns are heard to the tune of music,",
          "Where evening prayers and aarti are sung daily, Jivandhara is that sweet melody,",
          "Where torrents of feelings flow, where warmth rains down,",
          "Jivandhara is the fragrance of the wet earth of the first rain,",
          "The star of the eyes of the late founder Shri Champaklal Shah,",
          "The beloved of God, the embodiment of compassion, and a true servant of the people,",
          "Jivandhara is the dream of Shree Sandipbhai Shah 🙏,",
          "Jivandhara is the pride of Gujarat, Jivandhara is the pride of Gujarat 🚩,",
          "A mother's protective gaze, a father's warmth...!",
          "That indeed is our Jivandhara! ✨,",
          "What more can I say? What is Jivandhara... Jivandhara is the affectionate home of elders! 💜"
        ],
        authorLabel: "Writer",
        authorName: "Dhruti Dwivedi",
        foundation: "Jivandhara Vruddhashram Parivar",
        readMore: "Read More",
        close: "Close"
      },
    },
    stats: {
      residents: "Residents in Lifetime Care",
      donors: "Donor Families Supporting Us",
      years: "Of Trusted Seva",
      tax: "12A & 80G Tax Compliant",
    },
    initiatives: {
      eyebrow: "Our Major Initiatives",
      heading: "Serving with Care, Compassion and Purpose",
      description:
        "Explore the major initiatives through which Jivandhara Old Age Home supports the health, dignity, nourishment and well-being of senior citizens and the wider community.",
      slides: {
        elderCare: {
          label: "Lifetime Care",
          title: "Residential Elder Care",
          body: "A secure and compassionate home offering lifelong care, companionship and personal attention to every resident.",
          cta: "View Elder Care",
        },
        healthcare: {
          label: "Medical Seva",
          title: "Healthcare & Rehabilitation",
          body: "On-campus clinic, doctor support, medicine aid and camps that keep our elders safe every day.",
          cta: "View Healthcare",
        },
        gaushala: {
          label: "Gauseva",
          title: "Vrindavan Gir Gaushala",
          body: "Nourishing milk and devoted gauseva that sustains our residents and honours sacred tradition.",
          cta: "View Gaushala",
        },
        donate: {
          label: "Daan",
          title: "Support Our Causes",
          body: "Sponsor meals, medical care or a resident — every contribution becomes warmth and dignity.",
          cta: "Donate Now",
        },
        tiffin: {
          label: "Annadan",
          title: "Tiffin Seva",
          body: "Nutritious meals delivered with care, extending Jivandhara Old Age Home’s seva beyond the campus.",
          cta: "View Tiffin Seva",
        },
        gallery: {
          label: "Moments",
          title: "Life Inside Jivandhara Old Age Home",
          body: "Festivals, care mornings and shared joy — glimpses of the family we build every day.",
          cta: "View Gallery",
        },
      },
    },
    story: {
      eyebrow: "Our noble",
      heading:
        "How a father's noble benevolence in 2002 created Gujarat's largest senior sanctuary.",
      chronicled: "Chronicled across two and a half decades",
      dropcap: "J",
      p1a: "ivandhara Old Age Home holds a special place in our hearts as it entered our lives through the benevolence of my late father, Shree Champaklal Ghelabhai Shah. He made a remarkable contribution by donating 10,000 square yards of land in Lambha, situated right in front of the Narol Industrial Expansion area in the southern region of Ahmedabad. He founded this home in ",
      p1bold: "2002",
      p1b: ", starting with just five rooms, a dining hall, a lovely garden, and a serene temple.",
      p2: "We faithfully followed his guidance and turned Jivandhara Old Age Home into a warm, loving, and supportive family. We made his vision come to life with the support of our outstanding trustees, generous donors, and dedicated staff, creating a sanctuary filled with heart, compassion, and respect. It is incredible to reflect on our journey; starting with just 17 residents, we now proudly hold the title of Gujarat's largest old age home, having space for up to 360 seniors.",
      p3: "As our Jivandhara Old Age Home family continued to thrive, we remained deeply committed to meeting the evolving physical, emotional, and spiritual needs of our elders. Back in December 2012, we introduced Sankul 1 with 22 rooms, along with additional facilities to enhance our elders' comfort. Then, in 2015, we proudly welcomed Sankul 2 featuring 28 rooms, and on May 21, 2022, we celebrated the inauguration of Sankul 3 (featuring Seva Sadan, Shanti Sadan, and Prem Bhavan) to accommodate our growing family.",
      p4: "At Jivandhara Old Age Home, we aim to provide a happy, dignified, and fulfilling environment. Every elderly person is cherished and finds great joy here, fostering a heartwarming and jubilant atmosphere. By becoming a part of our community, you can enrich our shared journey and contribute to the honor and happiness of our residents.",
    },
    milestones: {
      eyebrow: "Milestones",
      heading: "A quarter century, one elder at a time",
      m2002: {
        title: "A Humble Beginning",
        body: "Established on 10,000 square yards of donated land in Lambha with 17 residents, 5 rooms, a dining hall, garden, and serene temple.",
      },
      m2011_gruh: {
        title: "Mahila Utkarsh Kendra – Sadguna Home Industry",
        body: "Launched our self-reliance cottage industry program, empowering elders and women with purposeful and food preparation seva.",
      },
      m2011_med: {
        title: "Bhagwan Mahavir Medical Centre",
        body: "Founded Bhagwan Mahavir Medical Centre providing daily outpatient consultations, regular check-ups, and free medicines.",
      },
      m2012: {
        title: "Sankul 1 Expansion",
        body: "Introduced Sankul 1 featuring 22 well-equipped rooms and modern utility amenities to enhance comfort and security for residents.",
      },
      m2014: {
        title: "Bhagwan Mahavir Senior Citizen Tiffin Seva",
        body: "Initiated community tiffin service to deliver fresh, hygienic, Jain-style cooked meals to needy and isolated senior citizens daily.",
      },
      m2015: {
        title: "Sankul 2 Welcomed",
        body: "Proudly welcomed Sankul 2 with 28 premium rooms, expanding our capacity to support our rapidly growing senior family.",
      },
      m2016: {
        title: "Bhagwan Mahavir Eye Care Hospital",
        body: "Commenced specialized eye care department, offering diagnostic screening, vision testing, and free cataract surgeries.",
      },
      m2017: {
        title: "Vrindavan Gir Gaushala",
        body: "Established Vrindavan Gir Gaushala, providing pure Gir cow milk for our elders and preserving sacred indigenous cattle care.",
      },
      m2018: {
        title: "Bhagwan Mahavir Physiotherapy Center",
        body: "Inaugurated Gujarat's first old age home paralysis rehabilitation & modern physiotherapy center dedicated to elder recovery.",
      },
      m2022: {
        title: "Sankul 3 Inauguration",
        body: "Inaugurated Sankul 3 (Seva Sadan, Shanti Sadan, and Prem Bhavan), raising our full welcoming capacity to 360+ elders.",
      },
      m2024_dental: {
        title: "Bhagwan Mahavir Dental Clinic",
        body: "Launched dedicated dental clinic unit equipped with modern dental chairs, oral hygiene care, and denture assistance for seniors.",
      },
      m2024_beyond: {
        title: "Continuing the Journey",
        body: "Ever-expanding our sacred mission of loving seva, modern health infrastructure, and lifelong shelter with dignity for all seniors.",
      },
      upcoming: {
        eyebrow: "What's Next",
        heading: "Upcoming Projects",
        years: "2027–2028",
        tag: "Upcoming",
        vatsalyadham: {
          title: "Jivandhara Vatsalyadham",
          body: "A large-scale old age home with a capacity to accommodate 2,500 senior citizens.",        },
        hospital: {
          title: "Usha Jeet Bhagwan Mahavir Hospital",
        },
        cancerCare: {
          title: "Bhagwan Mahavir Karunalaya – Cancer Care Centre",
        },
        paralysisRehab: {
          title: "Paralysis Rehabilitation Centre",
        },
      },
    },
    mvv: {
      mission: {
        tag: "Mission",
        title: "Unwavering Support & Care",
        body: "To be there for our elders just as parents are always there to support their children after every fall, offering them unconditional love, shelter, and comfort in their faltering years.",
      },
      vision: {
        tag: "Vision",
        title: "A Companion for the Lonely",
        body: "To provide a secure and warm sanctuary for those who never married, childless couples approaching their golden years, and surviving partners who have lost their spouses, ensuring no senior is left alone.",
      },
      values: {
        tag: "Values",
        title: "Dignity, Peace & Joy",
        body: "Providing a happy and fulfilling environment where every resident lives with ease, respect, and deep spiritual solace. Fostering a heartwarming and jubilant atmosphere.",
      },
    },
    triptych: {
      eyebrow: "Inside the Home",
      heading: "A Closer Look inside Jivandhara Old Age Home",
      description:
        "Spanning a massive 10,000 square yards, Jivandhara Old Age Home offers extensive, high-quality modern facilities designed to cater to the complete physical, medical, emotional, and spiritual well-being of our 300+ elders.",
      careAlt: "Caretaker with a resident in a comfortable setting",
      mealAlt: "Residents sharing a meal in the dining hall",
      medicalAlt: "Doctor providing medical care to a resident",
      morningsLabel: "Comfort & Well-being",
      morningsText:
        "Beautifully comfortable rooms, spacious communal Dining Hall, nutritious milk from our self-operated Vrindavan Gir Gaushala, and Hair Salon.",
      afternoonsLabel: "Health & Rehabilitation",
      afternoonsText:
        "Bhagavan Mahavir Medical Center, 24-Hour MBBS Doctors, Physiotherapy & Gujarat's first old age home paralysis rehabilitation center.",
      eveningsLabel: "Spirituality & Recreation",
      eveningsText:
        "Dada Bhagwan Jin Mandir, Vasupujya Swami Jain Temple, Swadhyay Hall, Library, Home Theater, and specialized Entertainment Rooms.",
    },
    trustee: {
      quote:
        "\"If you have ever wondered whether one act of kindness can change a life — visit us on a Sunday. You will leave with the answer.\"",
      name: "Smt. Saraswati Jain",
      role: "Trustee · Resident Welfare",
    },
    cta: {
      headingStart: "Become part of ",
      headingHighlight: "our family.",
      description:
        "Sponsor a resident. Sponsor a meal. Sponsor a medical day. Or simply walk in for tea. Every form of seva is welcomed and remembered.",
      donateNow: "Donate Now",
      meetTrustees: "Meet Our Trustees",
      visitUs: "Visit Us",
    },
  },
  contact: {
    hero: {
      eyebrow: "Get in touch",
      title: "Contact Us",
      subtitle:
        "Questions, volunteering, partnerships — we'd love to hear from you.",
    },
    imageAlt: "Jivandhara trust",
    info: {
      addressLabel: "Address",
      addressValue: "Padmavati Nagar, Indira Nagar, Vibhag 2, Lambha, Ahmedabad – 382405",
      phoneLabel: "Phone",
      phoneValue: "+91 9725521170, +91 8758413564, +91 9978015424",
      emailLabel: "Email",
      emailValue: "jivandharavrudhashram@gmail.com",
      hoursLabel: "Visiting Hours",
      hoursValueMorning: "9 am to 12 pm",
      hoursValueEvening: "3 pm to 7 pm",
    },
    form: {
      heading: "Send us a message",
      fullName: "Full Name",
      mobile: "Mobile",
      email: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Send Message",
      sending: "Sending...",
    },
    toast: {
      success: "Message sent. We'll get back to you soon.",
      error: "Could not send your message. Please try again.",
    },
  },
  donateHub: {
    hero: {
      liveDonations: "Live donations",
      titleLine1: "Your kindness keeps",
      titleLine2: "our elders thriving.",
      subtitle:
        "Pick a cause that moves your heart — from one-day meal seva to sponsoring an entire room. Every contribution is acknowledged with an 80G receipt.",
      browseCauses: "Browse Causes",
      donateInKind: "Donate In-Kind",
      totalRaised: "Total raised across drives",
      ofGoal: "of {goal} goal",
      pctReached: "{pct}% reached",
      activeDrivesCount: "{count} active drives",
      activeDrivesLabel: "Active drives",
      taxEligibleLabel: "80G eligible",
    },
    filter: {
      all: "All",
      inKind: "In-Kind",
    },
    causes: {
      ongoingTitle: "Ongoing Causes",
      ongoingSubtitle:
        "Help us reach the goal — every contribution moves the needle.",
      browseCategorySubtitle: "Browse campaigns in this category.",
      allCategorySubtitle: "All active campaigns under {category}.",
      noCampaignsFound: "No campaigns found in this category yet.",
      loadingCauses: "Loading causes…",
      unableToLoad: "Unable to load campaigns. Please try again later.",
    },
    inKindBanner: {
      title: "Donate in-kind",
      subtitle:
        "Food grains, clothes, blankets, medicines, furniture, medical equipment — submit a quick form and our team will coordinate pickup.",
      cta: "Submit In-Kind Form",
    },
    trust: {
      transparentTitle: "100% transparent",
      transparentBody:
        "Every donation is tracked and acknowledged with a digital receipt.",
      taxTitle: "80G tax benefit",
      taxBody:
        "Official 80G receipt issued within 24 hours of confirmed payment.",
      communityTitle: "Trusted community",
      communityBody:
        "Backed by trustees, volunteers and thousands of generous donors.",
    },
    card: {
      fundedPct: "{pct}% funded",
      stillNeeded: "{amount} still needed",
      ofTarget: "of {target}",
      donateNow: "Donate now",
    },
  },
  itemDonation: {
    hero: {
      eyebrow: "Item Donation",
      title: "Choose how you'd like to donate",
      subtitle: "Give essentials or donate usable scrap items — both help us care better for our elders every day.",
    },
    inKindCard: {
      title: "In-Kind Donation",
      subtitle: "Give essentials. Spread happiness.",
      description: "Donate items like food grains, new equipments, clothes, furniture and more. Your kindness helps us care better, every single day.",
      feature1: "Support daily needs",
      feature2: "100% goes to seva",
      feature3: "Make a direct impact",
      ctaLabel: "Donate In-Kind Items",
      imageAlt: "In-kind donation box with grains and essentials",
    },
    scrapCard: {
      title: "Scrap Donation",
      subtitle: "Old for you, useful for us.",
      description: "Donate your old furniture, fridge, appliances and other usable items. We'll pick it up from your location twice a week in Ahmedabad.",
      feature1: "Free pickup service",
      feature2: "Reuse & reduce waste",
      feature3: "Support a noble cause",
      ctaLabel: "Donate Scrap Items",
      imageAlt: "Furniture and appliances for scrap donation",
    },
    footerNotice: "Every donation, big or small, brings comfort, care and smiles to our elders.",
  },
  inkindDonation: {
    hero: {
      eyebrow: "In-Kind Donation",
      title: "In-Kind Donation",
      subtitle: "Donate food grains, clothes, blankets, medicines, furniture or any useful items. Fill the form and our team will coordinate pickup or drop-off.",
    },
    backLink: "Back to donation types",
    successTitle: "Thank You for Your In-Kind Donation!",
    successDesc: "Our team will contact you within 24 hours to arrange the in-kind donation collection/receipt.",
    successDetails: "Donation Details",
    donorName: "Donor Name",
    mobileNumber: "Mobile Number",
    itemCategory: "Item Category",
    quantity: "Quantity",
    unit: "Unit",
    itemName: "Item Name",
    needPickup: "Need Pickup",
    pickupAddress: "Pickup Address",
    submitAnother: "Submit Another Donation",
    browseCauses: "Browse Causes",
    sections: {
      yourDetails: "Your details",
      whatToDonate: "What you'd like to donate",
      pickupDetails: "Pickup details",
    },
    labels: {
      fullName: "Full Name",
      mobile: "Mobile",
      email: "Email",
      category: "Item Category",
      selectCategory: "Select category",
      quantity: "Quantity",
      quantityPlaceholder: "e.g. 2",
      unit: "Unit",
      selectUnit: "Select unit",
      unitQty: "Quantity per unit / total weight",
      itemName: "Item Name / Description",
      itemNamePlaceholder: "Rice, Winter blankets, Wheelchair…",
      preferredDate: "Preferred Donation Date",
      needPickupToggle: "Need pickup?",
      needPickupHelp: "Turn on to share pickup address details",
      pickupAddress: "Pickup Address",
      pickupAddressPlaceholder: "House / flat no., street, society name",
      area: "Area",
      areaPlaceholder: "Maninagar",
      landmark: "Landmark",
      landmarkPlaceholder: "Near bus stop",
      pincode: "Pincode",
      pincodePlaceholder: "380008",
      message: "Message / Notes",
      messagePlaceholder: "New condition preferred, pickup timing, etc.",
      submit: "Submit In-Kind Donation",
      submitting: "Submitting…",
    },
  },
  scrapDonation: {
    hero: {
      eyebrow: "Scrap Donation",
      title: "Scrap Donation",
      subtitle: "Donate old furniture, appliances and other usable items. We offer free pickup twice a week in Ahmedabad.",
    },
    backLink: "Back to donation types",
    successTitle: "Thank You for Your Scrap Donation!",
    successDesc: "Our team will contact you to schedule a free pickup for your scrap items in Ahmedabad.",
    successDetails: "Donation Details",
    donorName: "Donor Name",
    mobileNumber: "Mobile Number",
    itemCategory: "Item Category",
    quantity: "Quantity",
    itemName: "Item Name",
    pickupAddress: "Pickup Address",
    submitAnother: "Submit Another Donation",
    browseCauses: "Browse Causes",
    sections: {
      yourDetails: "Your details",
      whatToDonate: "What you'd like to donate",
      pickupDetails: "Pickup details",
      itemPhoto: "Item Photo",
    },
    labels: {
      fullName: "Full Name",
      mobile: "Mobile",
      email: "Email",
      category: "Item Category",
      selectCategory: "Select category",
      quantity: "Quantity",
      quantityPlaceholder: "e.g. 1",
      itemName: "Item Name / Description",
      itemNamePlaceholder: "Old refrigerator, wooden chair, washing machine…",
      pickupAddress: "Pickup Address",
      pickupAddressPlaceholder: "House / flat no., street, society name",
      area: "Area",
      areaPlaceholder: "Maninagar",
      landmark: "Landmark",
      landmarkPlaceholder: "Near bus stop",
      pincode: "Pincode",
      pincodePlaceholder: "380008",
      photoHelp: "Upload a photo of the item to help us plan pickup (optional, max 5 MB).",
      uploadPhoto: "Upload photo",
      changePhoto: "Change photo",
      removePhoto: "Remove",
      message: "Message / Notes",
      messagePlaceholder: "Preferred pickup time, gate access instructions…",
      submit: "Submit Scrap Donation",
      submitting: "Submitting…",
    },
  },
};

export default pages;
